export default __webpack_public_path__ + "images/WM.52c3ab9.png";